import { render } from "./ForgotPasswordForm.vue.js?vue&type=template&id=19fcabeb!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ForgotPasswordForm.vue?vue&type=template&id=19fcabeb"
import script from "./ForgotPasswordForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ForgotPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/auth/ForgotPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19fcabeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19fcabeb', __exports__)) {
    api.reload('19fcabeb', __exports__)
  }
  
  module.hot.accept("./ForgotPasswordForm.vue.js?vue&type=template&id=19fcabeb!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ForgotPasswordForm.vue?vue&type=template&id=19fcabeb", () => {
    api.rerender('19fcabeb', render)
  })

}


export default __exports__